import trackerApi from '../../src/api/tracker';

export const setCustumerName =  (NAME)=>{
  return { type: 'SET_NAME' , payload: NAME};
};

export const setCustumerPhone =  (PHONE)=>{
  return { type: 'SET_PHONE' , payload: PHONE};
};

export const setCustumerAddress =  (ADDRESS)=>{
  return { type: 'SET_ADDRESS' , payload: ADDRESS};
};

export const setCustumerProvince =  (PROVINCE)=>{
  return { type: 'SET_PROVINCE' , payload: PROVINCE};
};

export const setCustumerCity =  (CITY)=>{
  return { type: 'SET_CITY' , payload: CITY};
};

export const setCustumerProblem =  (PROBLEM)=>{
  return { type: 'SET_PROBLEM' , payload: PROBLEM};
};

export const setCategory =  (CATEGORY)=>{
  return { type: 'SET_CATEGORY' , payload: CATEGORY};
};

export const setModel =  (MODEL)=>{
  return { type: 'SET_MODEL' , payload: MODEL};
};

export const setReqType =  (TYPE)=>{
  return { type: 'SET_TYPE' , payload: TYPE};
};
export const setMaq =  (TYPE)=>{
  return { type: 'SET_MAQ' , payload: TYPE};
};

export const saveNewAddress =  (func)=>{
  return { type: 'SAVE', payload: func };
};
